/**
 * Google maps callback function for auto complete address
 *
 * @class GoogleMapsAddressAutocomplete
 *
 * @see https://developers.google.com/maps/documentation/javascript/examples/places-autocomplete-addressform
 */
export class GoogleMapsAddressAutocomplete {
  /**
   * @constructor
   */
  constructor() {
    this.initAutocomplete()
  }

  /**
   * @public
   */
  initAutocomplete() {
    // Autocomplete Address
    const autoCompleteAddressForms = document.querySelectorAll('[data-autocomplete-address]')
    if (!autoCompleteAddressForms) {
      return
    }

    for (let i = 0; i < autoCompleteAddressForms.length; i++) {
      const autoCompleteAddressForm = autoCompleteAddressForms[i]
      const type = (autoCompleteAddressForm.dataset.autocompleteAddressField === 'mini') ? [ '(cities)' ] : [ 'address' ]
      const autocompleteAddressOptions = {
        types:                 type,
        componentRestrictions: { country: 'US' }
      }

      /* global google */
      const autocomplete = new google.maps.places.Autocomplete(autoCompleteAddressForm, autocompleteAddressOptions)
      autocomplete['page'] = autoCompleteAddressForm.getAttribute('data-autocomplete-address')

      autocomplete.addListener('place_changed', function() {
        this.fillInAddress(autocomplete)
      }.bind(this))
    }
  }

  /**
   * Auto complete address full form
   *
   * @param {object} autocomplete
   */
  fillInAddress(autocomplete) {
    const autocompleteAddressField = document.querySelector(`[data-autocomplete-address="${autocomplete['page']}"]`)
    const addressFields = autocompleteAddressField.closest('[data-form-page]')
    const place = autocomplete.getPlace()

    if (place && place.address_components && addressFields) {
      for (let i = 0; i < place.address_components.length; i++) {
        const valueObj = place.address_components[i]
        const addressType = place.address_components[i].types[0]
        const field = addressFields.querySelector(`[data-autocomplete-address-field="${addressType}"]`)

        let changeEvent
        if (document.createEvent) {
          changeEvent = document.createEvent('HTMLEvents')
          changeEvent.initEvent('change', true, true)
        } else {
          changeEvent = document.createEventObject()
          changeEvent.eventType = 'change'
        }

        switch (addressType) {
          case 'street_number':
          case 'route':
            const streetField = addressFields.querySelector('[data-autocomplete-address-field="street"]') /* eslint "no-case-declarations": 0 */

            if (streetField) {
              streetField.value = place.name
              streetField.dispatchEvent(changeEvent)
            }

            break
          case 'administrative_area_level_1':
            if (field) {
              field.value = valueObj['long_name']
              field.dispatchEvent(changeEvent)
            }

            break
          default:
            if (field) {
              field.value = valueObj['long_name']
              field.dispatchEvent(changeEvent)
            }
        }
      }
    }
  }
}

window.initGoogleMapsAddressAutocomplete = () => { new GoogleMapsAddressAutocomplete() }
